var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVerbLiveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100px",
    height: "100px",
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group Copy") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 100,
    height: 100,
    rx: 22
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "6.73637361%",
    y1: "6.32928885%",
    x2: "94.45503%",
    y2: "93.7264287%",
    id: "linearGradient-3"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#936EFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8A77FF",
    offset: "33.5569902%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3FC5FF",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "v40-434",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "v40-434-1",
    transform: "translate(-910.000000, -221.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(803.000000, 221.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-Copy",
    transform: "translate(107.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Rectangle-Copy",
    fill: "#D8D8D8",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Square",
    fill: "url(#linearGradient-3)",
    mask: "url(#mask-2)",
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#000000",
    mask: "url(#mask-2)",
    cx: 50,
    cy: 50,
    r: 35.2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ring",
    stroke: "#000000",
    strokeWidth: 2,
    mask: "url(#mask-2)",
    cx: 49.8,
    cy: 50,
    r: 38.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.175,37.6 L54.2525862,37.6 C55.0119777,37.6 55.6275862,38.2156085 55.6275862,38.975 L55.6275862,61.425 C55.6275862,62.1843915 55.0119777,62.8 54.2525862,62.8 L32.175,62.8 C31.4156085,62.8 30.8,62.1843915 30.8,61.425 L30.8,38.975 C30.8,38.2156085 31.4156085,37.6 32.175,37.6 Z M59.4112907,43.3969178 L69.0750838,40.8539085 C69.8094738,40.6606551 70.5614773,41.099333 70.7547307,41.833723 C70.784785,41.9479336 70.8,42.0655404 70.8,42.1836392 L70.8,58.2163608 C70.8,58.9757524 70.1843915,59.5913608 69.425,59.5913608 C69.3069012,59.5913608 69.1892945,59.5761458 69.0750838,59.5460915 L59.4112907,57.0030822 C58.8072293,56.8441246 58.3862069,56.2979776 58.3862069,55.6733516 L58.3862069,44.7266484 C58.3862069,44.1020224 58.8072293,43.5558754 59.4112907,43.3969178 Z",
    id: "Icon-Color",
    fill: "#FFFFFF",
    mask: "url(#mask-2)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerbLiveIcon);
export default __webpack_public_path__ + "static/media/verb-live-icon.2f205ac5366cd94095115c3bf3a12651.svg";
export { ForwardRef as ReactComponent };